import useTracksStore, { MIX_ID } from '../tracks.store.tsx'
import { refreshAudioMix } from './refresh-audio-mix.ts'
import useAudioStore from '../audio.store.tsx'
import { useHistoryStore } from '../history.store.tsx'

export const soloTrack = async (id: string): Promise<void> => {
  useTracksStore.getState().solo(id)
  useHistoryStore.getState().saveSnapshot()
  useTracksStore.getState().setGeneratedMix(undefined)

  if (useAudioStore.getState().currentAudioId !== MIX_ID) return
  await refreshAudioMix(false)
}
